export const useLogout = async () => {
  const { csrf } = useAuth()

  const { data, error } = await useFetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include',
    headers: { 'x-csrf': csrf.value || '' }
  })
  if (error.value) return alert('Logout failed')
  // Native logout returns redirectTo='/login' (no IdP round-trip); OIDC logout
  // returns the Microsoft end-session URL. endSessionUrl is the legacy field,
  // kept as a fallback. Always full-navigate so the session is fully cleared.
  const d = data.value as any
  window.location.href = d?.redirectTo || d?.endSessionUrl || '/login'

  // const csrf = useCookie<string | null>('csrf')
  //
  // const { data, error } = await useFetch('/api/auth/logout', {
  //   method: 'POST',
  //   credentials: 'include',
  //   headers: {
  //     'x-csrf': csrf.value || ''
  //   }
  // })
  //
  // if (error.value) {
  //   // you can show a toast here
  //   throw error.value
  // }
  //
  // const url = data.value?.endSessionUrl
  // if (url) {
  //   window.location.href = url
  // }
}
